export default "__VITE_ASSET__53219e2c__"